<!--
 * @Description: brand-list
 * @Author: pliybird
 * @Date: 2022-01-24 11:20:04
 * @LastEditTime: 2023-08-23 16:44:42
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<template>
    <div>

        <ul v-if="brandFrom=='home'"  ref="myElement" :class="[
                `brand-list`,
                {'brand-style-1': brandStyle === 1},
                {'brand-style-2': brandStyle === 2},
                {'brand-style-2': brandStyle === 3},
                {'brand-style-2 variation-2': brandStyle === 4},
            ]">
            <li v-for="(brand, index) in brandList?.slice(0,len)" class="line-bt-5" :key="index">
                <div class="img">
                    <img :src="`${baseUrl}/${brand.logoUrl}`" :alt="brand.title" />
                </div>
                <router-link class="image" :to="{name:'CasesDetail',params:{lang:$i18n.locale,id:brand.id,from:'cases'}}" v-show="showDetail(brand.lang)">
                    {{$t("home.view")}}
                </router-link>
            </li>
        </ul>
        <ul v-if="brandFrom=='cases'"  :class="[
                `brand-list`,
                {'brand-style-1': brandStyle === 1},
                {'brand-style-2': brandStyle === 2},
                {'brand-style-2': brandStyle === 3},
                {'brand-style-2 variation-2': brandStyle === 4},
            ]">
            <li v-for="(brand, index) in brandList" :key="index" :class="[
                {'line-bt-5':brandList.length%5===0},
                {'line-bt-4':brandList.length%5===4},
                {'line-bt-3':brandList.length%5===3},
                {'line-bt-2':brandList.length%5===2},
                {'line-bt-1':brandList.length%5===1},
                ]">
                <div class="img">
                    <img :src="`${baseUrl}/${brand.logoUrl}`" :alt="brand.title" />
                </div>
                
                <router-link class="image" :to="{name:'CasesDetail',params:{lang:$i18n.locale,id:brand.id,from:'cases'}}" v-show="showDetail(brand.lang)">
                    {{$t("home.view")}}
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'Brand',
        props: {
            brandList: [],
            brandStyle: {
                type: Number,
                default: 1
            },
            brandFrom:{
                type:String,
                default:'home'
            }
        },
        // directives:{
        //     resize: {
        //         bind(el, binding) { 
        //         let width = '', height = '';
        //         function isReize() {
        //             const style = document.defaultView.getComputedStyle(el);
        //             if (width !== style.width || height !== style.height) {
        //             binding.value({width:style.width,height:style.height});  // 关键(这传入的是函数,所以执行此函数)
        //             }
        //             // console.log(style)
        //             width = style.width;
        //             height = style.height;
        //         }
        //         el.__vueSetInterval__ = setInterval(isReize, 300);
        //         },
        //         unbind(el) {
        //             clearInterval(el.__vueSetInterval__);
        //         }
        //     }
        // },
        mounted() {
            if(this.brandFrom == 'home'){

                this.getElementWidth(); // 获取初始宽度
    
                this.resizeObserver = new ResizeObserver(this.getElementWidth);
                this.resizeObserver.observe(this.$refs.myElement); // 监听元素大小变化
            }
        },
     
        beforeDestroy(){
            this.brandFrom == 'home' && this.resizeObserver.disconnect(); // 停止监听
        },
        methods: {
            showDetail(lang){
                return lang?.split(',').includes(this.$i18n.locale)
            },
            getElementWidth() {
                if(this.brandList){
                    this.$nextTick(() => {
                        if(this.$refs.myElement.offsetWidth<459){
                            this.len = 6
                        }else if(this.$refs.myElement.offsetWidth<635 && this.$refs.myElement.offsetWidth>459){
                            this.len = 15
                        }else{
                            this.len = 20
                        }
                    });
                }
            },
        },
        data(){
            return {
                baseUrl:process.env.VUE_APP_API_URL,
                len:20,
                resizeObserver: null,
            }
        },
    }
</script>